import React from 'react';

const RouterContent = ({
  active,
  children,
}) => {
  return (
    <div className={'tab-content'}>
      <div className={'tab-pane active'}>
        {children[active] || null}
      </div>
    </div>
  );
};

export default RouterContent;